import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import userReducer from './reducers/userReducers';
import authReducer from './reducers/authReducer';
import appReducer from './reducers/appReducer';
import collectionReducer from './reducers/collectionReducer';
import workspaceReducers from './reducers/workspaceReducers';
import invitesReducer from './reducers/invitesReducer';
import sessionReducer from './reducers/sessionReducer';
import subscriptionReducer from './subscriptionSlice';
var sentryReduxEnhancer = Sentry.createReduxEnhancer();
export var store = configureStore({
    reducer: {
        user: userReducer,
        app: appReducer,
        auth: authReducer,
        collection: collectionReducer,
        workspace: workspaceReducers,
        invites: invitesReducer,
        session: sessionReducer,
        subscription: subscriptionReducer,
    },
    enhancers: [sentryReduxEnhancer],
});
